import React from 'react';

interface Props {
  scale?: number;
  color?: string;
  viewBox?: string;
}

const Increase = ({ scale = 1, color = '#FFFFFF', viewBox = '0 0 16 16' }: Props) => {
  const width = `${scale * 16}`;
  const height = `${scale * 16}`;

  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.66667 9.90476L5.64022 7.92006C6.13196 6.9176 7.57723 6.96656 8 8C8.42277 9.03344 9.86804 9.0824 10.3598 8.07994L11.3333 6.09524M8 14C5.50018 14 4.25027 14 3.37405 13.3634C3.09107 13.1578 2.84221 12.9089 2.63661 12.626C2 11.7497 2 10.4998 2 8C2 5.50018 2 4.25027 2.63661 3.37405C2.84221 3.09107 3.09107 2.84221 3.37405 2.63661C4.25027 2 5.50018 2 8 2C10.4998 2 11.7497 2 12.626 2.63661C12.9089 2.84221 13.1578 3.09107 13.3634 3.37405C14 4.25027 14 5.50018 14 8C14 10.4998 14 11.7497 13.3634 12.626C13.1578 12.9089 12.9089 13.1578 12.626 13.3634C11.7497 14 10.4998 14 8 14Z"
        stroke={color}
        strokeLinecap="round"
      />
    </svg>
  );
};

export default Increase;
